"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeResponseWithAcceptanceAllOfToJSON = exports.ChallengeResponseWithAcceptanceAllOfFromJSONTyped = exports.ChallengeResponseWithAcceptanceAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
function ChallengeResponseWithAcceptanceAllOfFromJSON(json) {
    return ChallengeResponseWithAcceptanceAllOfFromJSONTyped(json, false);
}
exports.ChallengeResponseWithAcceptanceAllOfFromJSON = ChallengeResponseWithAcceptanceAllOfFromJSON;
function ChallengeResponseWithAcceptanceAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isAccepted': !(0, runtime_1.exists)(json, 'isAccepted') ? undefined : json['isAccepted'],
    };
}
exports.ChallengeResponseWithAcceptanceAllOfFromJSONTyped = ChallengeResponseWithAcceptanceAllOfFromJSONTyped;
function ChallengeResponseWithAcceptanceAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isAccepted': value.isAccepted,
    };
}
exports.ChallengeResponseWithAcceptanceAllOfToJSON = ChallengeResponseWithAcceptanceAllOfToJSON;
